import React, { useState } from "react";
import { 
  Box, 
  TextField, 
  MenuItem, 
  FormControl, 
  InputLabel, 
  Select, 
  Button,
  useMediaQuery,
  useTheme,
  Grid
} from "@mui/material";

const FilterAndSearch = ({ onFilterChange, onSearchChange, onDateRangeChange }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  
  const [searchTerm, setSearchTerm] = useState("");
  const [filterType, setFilterType] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (onSearchChange) onSearchChange(value);
  };

  const handleFilterChange = (e) => {
    const value = e.target.value;
    setFilterType(value);
    if (onFilterChange) onFilterChange(value);
  };

  const handleDateRangeChange = () => {
    if (onDateRangeChange) onDateRangeChange({ fromDate, toDate });
  };

  const handleClearFilters = () => {
    setSearchTerm("");
    setFilterType("");
    setFromDate("");
    setToDate("");
    if (onSearchChange) onSearchChange("");
    if (onFilterChange) onFilterChange("");
    if (onDateRangeChange) onDateRangeChange({ fromDate: "", toDate: "" });
  };

  return (
    <Box sx={{ mb: { xs: 1.5, sm: 2 } }}>
      <Grid container spacing={{ xs: 1, sm: 1.5 }}>
        {/* حقل البحث */}
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="بحث"
            value={searchTerm}
            onChange={handleSearchChange}
            variant="outlined"
            size="small"
            placeholder="ابحث..."
            fullWidth
            InputLabelProps={{ 
              style: { fontSize: isMobile ? "13px" : "14px" } 
            }}
            InputProps={{
              style: { fontSize: isMobile ? "13px" : "14px" }
            }}
          />
        </Grid>

        {/* فلتر النوع */}
        <Grid item xs={12} sm={6} md={2}>
          <FormControl size="small" fullWidth>
            <InputLabel sx={{ fontSize: { xs: "13px", sm: "14px" } }}>
              النوع
            </InputLabel>
            <Select
              value={filterType}
              onChange={handleFilterChange}
              label="النوع"
              sx={{ fontSize: { xs: "13px", sm: "14px" } }}
            >
              <MenuItem value="" sx={{ fontSize: { xs: "13px", sm: "14px" } }}>
                الكل
              </MenuItem>
              <MenuItem value="deposit" sx={{ fontSize: { xs: "13px", sm: "14px" } }}>
                إيداع
              </MenuItem>
              <MenuItem value="withdrawal" sx={{ fontSize: { xs: "13px", sm: "14px" } }}>
                سحب
              </MenuItem>
              <MenuItem value="transfer_out" sx={{ fontSize: { xs: "13px", sm: "14px" } }}>
                ترحيل للخارج
              </MenuItem>
              <MenuItem value="transfer_in" sx={{ fontSize: { xs: "13px", sm: "14px" } }}>
                ترحيل للداخل
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>

        {/* من تاريخ */}
        <Grid item xs={6} sm={6} md={2}>
          <TextField
            label={isMobile ? "من" : "من تاريخ"}
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            InputLabelProps={{ 
              shrink: true,
              style: { fontSize: isMobile ? "13px" : "14px" } 
            }}
            InputProps={{
              style: { fontSize: isMobile ? "13px" : "14px" }
            }}
            size="small"
            fullWidth
          />
        </Grid>

        {/* إلى تاريخ */}
        <Grid item xs={6} sm={6} md={2}>
          <TextField
            label={isMobile ? "إلى" : "إلى تاريخ"}
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            InputLabelProps={{ 
              shrink: true,
              style: { fontSize: isMobile ? "13px" : "14px" } 
            }}
            InputProps={{
              style: { fontSize: isMobile ? "13px" : "14px" }
            }}
            size="small"
            fullWidth
          />
        </Grid>

        {/* أزرار التحكم */}
        <Grid item xs={6} sm={6} md={1.5}>
          <Button
            variant="outlined"
            color="primary"
            size="small"
            onClick={handleDateRangeChange}
            fullWidth
            sx={{ 
              fontSize: { xs: "12px", sm: "13px" },
              height: "40px",
              whiteSpace: "nowrap",
            }}
          >
            {isMobile ? "بحث" : "تطبيق"}
          </Button>
        </Grid>

        <Grid item xs={6} sm={6} md={1.5}>
          <Button
            variant="outlined"
            color="secondary"
            size="small"
            onClick={handleClearFilters}
            fullWidth
            sx={{ 
              fontSize: { xs: "12px", sm: "13px" },
              height: "40px",
              whiteSpace: "nowrap",
            }}
          >
            مسح
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default FilterAndSearch;
